import React from "react";
import Management from "components/general/Management";

const UniversityStudent = () => {
    const layout = [
        [
            { label: "Họ", name: "last_name", type: "input", rules: [{ required: true }] },
            { label: "Tên đệm và tên", name: "first_name", type: "input", rules: [{ required: true }] }
        ],
        [
            { label: "Ngày sinh", name: "birthday", type: "date", rules: [{ required: true }] },
            { label: "Mã sinh viên", name: "student_number", type: "input", rules: [{ required: true }] },
        ],
        [
            {
                label: "Email",
                name: "email",
                type: "input",
                rules: [
                    { required: true, message: "Vui lòng nhập email!" },
                    { type: "email", message: "Email không hợp lệ!" },
                ],
            },
        ],
    ];

    const columns = [
        { title: "Mã SV", dataIndex: "student_number", key: "student_number" },
        { title: "Username", dataIndex: "username", key: "username" },
        { title: "Tên", dataIndex: "first_name", key: "first_name" },
        { title: "Họ", dataIndex: "last_name", key: "last_name" },
        { title: "Ngày sinh", dataIndex: "birthday", key: "birthday", render: value => value?.format("DD/MM/YYYY")},
        { title: "Email", dataIndex: "email", key: "email" },
    ];

    return (
        <div>
            <h2>Quản Lý Sinh Viên</h2>
            <Management
                layout={layout}
                columns={columns}
                apiPath="/students/"
                itemName="sinh viên"
                listMode="table"
                useFrontendPagination={false}
                disableSearch={false}
                excelImportExportOptions={{
                    apiPath: "/students/",
                    itemName: "sinh viên",
                    exportFields: ["student_number", "username", "first_name", "last_name", "email"],
                    expectedCsvType: "students",
                }}
                dateFields={[
                    { field: "birthday", type: "date" }
                ]}
            />
        </div>
    );
};

export default UniversityStudent;
